module.exports = __webpack_public_path__ + "img/party.d19ecf73.svg";